import { RootState } from "@/store/store";
import { GetUsersMeOrganisationsCurrentBudgetsByBudgetIdAccumulatedCostsApiArg } from "@/services/cloudchipr.api";
import { budgetDetailsDrawerIdSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsDrawerIdSelector";
import { budgetDetailsDrawerAccumulatedCostDateSelector } from "@/store/budgets/selectors/details-drawer/accumulated-cost/budgetDetailsDrawerAccumulatedCostDateSelector";
import { budgetDetailsPeriodSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsPeriodSelector";
import { budgetDetailsEndDateSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsEndDateSelector";
import { getBudgetDetailsDateToFromPeriod } from "@/store/budgets/utils/helpers/getBudgetDetailsDateToFromPeriod";

export const budgetDetailsAccumulatedCostPayloadSelector = (
  state: RootState,
):
  | GetUsersMeOrganisationsCurrentBudgetsByBudgetIdAccumulatedCostsApiArg
  | undefined => {
  const budgetId = budgetDetailsDrawerIdSelector(state);
  const period = budgetDetailsPeriodSelector(state);
  const endDate = budgetDetailsEndDateSelector(state);
  const date = budgetDetailsDrawerAccumulatedCostDateSelector(state);

  if (!budgetId || !date) {
    return;
  }

  const dateTo = getBudgetDetailsDateToFromPeriod(date, endDate, period);

  return {
    "budget-id": budgetId,
    dateFrom: date,
    dateTo: dateTo ?? "",
  };
};
